<template>
  <section class="honor-container" ref="rootRef">

    <!-- FLORES -->
    <img
      ref="florIzq"
      src="@/assets/flor3.png"
      class="flor flor-izq"
      alt=""
    />

    <img
      ref="florDer"
      src="@/assets/flor3.png"
      class="flor flor-der"
      alt=""
    />

    <!-- CONTENIDO -->
    <div class="frase-container">

      <!-- TITULO -->
      <p ref="tituloRef" class="titulo-padrinos">
        Padrinos principales
      </p>

      <!-- LINEA -->

      <!-- NOMBRES -->
      <p ref="nombre1Ref" class="nombre-padrino">
        Javier Arreguin
      </p>
        <!-- NOMBRES -->
      <p ref="nombre2Ref" class="nombre-padrino">
        Judith Arreguin
      </p>

    </div>

  </section>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {

  name: 'CuadroDeHonor',

  setup() {

    const rootRef = ref(null)

    const florIzq = ref(null)
    const florDer = ref(null)

    const tituloRef = ref(null)
    const tituloHonorRef = ref(null)

    const nombre1Ref = ref(null)
    const nombre2Ref = ref(null)
    const nombre3Ref = ref(null)
    const nombre4Ref = ref(null)

    const lineaRef = ref(null)
    const linea2Ref = ref(null)

    onMounted(async () => {

      await nextTick()

      // ESTADO INICIAL
      gsap.set(
        [
          tituloRef.value,
          tituloHonorRef.value,

          nombre1Ref.value,
          nombre2Ref.value,
          nombre3Ref.value,
          nombre4Ref.value,

          lineaRef.value,
          linea2Ref.value
        ],
        {
          opacity: 0,
          y: 40
        }
      )

      gsap.set(
        [florIzq.value, florDer.value],
        {
          opacity: 0,
          scale: 0.7,
          rotation: -8
        }
      )

      const io = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

          if (!entry.isIntersecting) return

          const tl = gsap.timeline({
            defaults: {
              ease: 'power3.out'
            }
          })

          // FLORES
          tl.to(
            florIzq.value,
            {
              opacity: 1,
              scale: 1,
              rotation: 0,
              duration: 1.2
            }
          )

          tl.to(
            florDer.value,
            {
              opacity: 1,
              scale: 1,
              rotation: 0,
              duration: 1.2
            },
            '-=1'
          )

          // TITULO PRINCIPAL
          tl.to(
            tituloRef.value,
            {
              opacity: 1,
              y: 0,
              duration: 1
            },
            '-=0.8'
          )

          // LINEA 1
          tl.to(
            lineaRef.value,
            {
              opacity: 1,
              scaleX: 1,
              duration: 0.8
            },
            '-=0.5'
          )

          // NOMBRE PRINCIPAL
          tl.to(
            nombre1Ref.value,
            {
              opacity: 1,
              y: 0,
              duration: 1
            },
            '-=0.3'
          )

          // TITULO HONOR
          tl.to(
            tituloHonorRef.value,
            {
              opacity: 1,
              y: 0,
              duration: 1
            },
            '-=0.3'
          )

          // LINEA 2
          tl.to(
            linea2Ref.value,
            {
              opacity: 1,
              scaleX: 1,
              duration: 0.8
            },
            '-=0.5'
          )

          // NOMBRES HONOR
          tl.to(
            [
              nombre2Ref.value,
              nombre3Ref.value,
              nombre4Ref.value
            ],
            {
              opacity: 1,
              y: 0,
              stagger: 0.2,
              duration: 1
            },
            '-=0.3'
          )

          // FLOTACION
          gsap.to(
            florIzq.value,
            {
              y: '-=12',
              duration: 3,
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut'
            }
          )

          gsap.to(
            florDer.value,
            {
              y: '-=14',
              duration: 3.4,
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut'
            }
          )

          io.disconnect()
        })

      }, { threshold: 0.3 })

      if (rootRef.value) {
        io.observe(rootRef.value)
      }
    })

    return {

      rootRef,

      florIzq,
      florDer,

      tituloRef,
      tituloHonorRef,

      nombre1Ref,
      nombre2Ref,
      nombre3Ref,
      nombre4Ref,

      lineaRef,
      linea2Ref
    }
  }
}
</script>

<style scoped>

.honor-container{
  position: relative;

  width: 100%;
  max-width: 1100px;

  margin: 0 auto;

  padding: 70px 22px 80px;

  overflow: hidden;

  background: #fff;

  box-sizing: border-box;
}

/* FLORES */

.flor{
  position: absolute;

  width: 170px;

  z-index: 1;

  pointer-events: none;
}

.flor-izq{
  left: -45px;
  top: 120px;

  transform: rotate(-10deg);
}

.flor-der{
  right: -45px;
  top: 100px;

  transform: scaleX(-1) rotate(-10deg);
}

/* CONTENIDO */

.frase-container{
  position: relative;

  z-index: 3;

  width: 100%;
  max-width: 700px;

  margin: 0 auto;

  text-align: center;
}

/* TITULOS */

.titulo-padrinos{
  font-family: 'quote', serif;

  font-size: 54px;

  color: #1f1f1f;

  line-height: 1.2;

  margin-bottom: 18px;
}

.titulo-secundario{
  margin-top: 45px;
}

/* LINEAS */

.linea-divisora{
  width: 120px;
  height: 2px;

  background: #efcad5;

  margin: 18px auto 30px;

  transform: scaleX(0);

  opacity: 0;

  border-radius: 999px;
}

/* NOMBRES */

.nombre-padrino{
  font-family: 'quote', cursive;

  font-size: 72px;

  color: #efcad5;

  line-height: 1.12;

  margin-bottom: 16px;
}

/* MOBILE */

@media (max-width: 768px){

  .honor-container{
    padding: 60px 22px 70px;
  }

  .flor{
    width: 120px;
  }

  .flor-izq{
    left: -70px;
    top: 120px;
  }

  .flor-der{
    right: -70px;
    top: 140px;
  }

  .titulo-padrinos{
    font-size: 28px;
  }

  .nombre-padrino{
    font-size: 32px;
  }

  .linea-divisora{
    width: 90px;
  }
}

</style>